import type { RouteRecordRaw } from 'vue-router'

const DashboardView = () => import('@/views/Dashboard/Index.vue')

const SettingsView = () => import('@/views/Settings/Index.vue')
const AccountSettingsView = () => import('@/views/Settings/Account/Index.vue')
const SettingsFundsView = () => import('@/views/Settings/Fund/Index.vue')
const SettingsPortfoliosView = () =>
  import('@/views/Settings/Portfolios/Index.vue')
const SettingsAdminsView = () => import('@/views/Settings/Admins/Index.vue')
const SettingsAdminsListView = () =>
  import('@/views/Settings/Admins/AdminsList.vue')
const SettingsAdminDetailView = () =>
  import('@/views/Settings/Admins/Detail/Index.vue')
const SettingsAdminsActivityLogView = () =>
  import('@/views/Settings/Admins/ActivityLog/Index.vue')

const FundView = () => import('@/views/Fund/Index.vue')
const FundCrmView = () => import('@/views/Fund/CRM/Index.vue')
const FundCrmClientsView = () => import('@/views/Fund/CRM/Clients.vue')
const FundCrmClientDetailView = () =>
  import('@/views/Fund/CRM/ClientDetail/Index.vue')
const FundCrmClientFundView = () => import('@/views/Fund/CRM/ClientFund.vue')
const FundFeesView = () => import('@/views/Fund/Fees/Index.vue')
const FundReferrerOnePagerView = () =>
  import('@/views/Fund/Fees/Referrers/ReferrerOnePager.vue')
const FundSeriesView = () => import('@/views/Fund/Series/Index.vue')

const AssetsView = () => import('@/views/Assets/Index.vue')
const AssetsPortfolioView = () => import('@/views/Assets/Portfolio/Index.vue')
const AssetSourcesView = () => import('@/views/Assets/AssetSources/Index.vue')
const AssetsExchangesView = () =>
  import('@/views/Assets/AssetSources/Exchanges/Index.vue')
const AssetsWalletsView = () =>
  import('@/views/Assets/AssetSources/Wallets/Index.vue')
const AssetsCryptoAssetsView = () =>
  import('@/views/Assets/AssetSources/CryptoAssets/Index.vue')
const AssetsCustomEntriesView = () =>
  import('@/views/Assets/AssetSources/CustomEntries/Index.vue')
const AssetsZeroPriceAssetsView = () =>
  import('@/views/Assets/ZeroPriceAssets/Index.vue')

const DeFiView = () => import('@/views/DeFi/Index.vue')
const LiquidityProvidingView = () =>
  import('@/views/DeFi/LiquidityProviding/Index.vue')

const StatisticsView = () => import('@/views/Statistics/Index.vue')
const StatisticsPerformanceIndexView = () =>
  import('@/views/Statistics/Performance/Index.vue')
const StatisticsPerformanceView = () =>
  import('@/views/Statistics/Performance/Performance/Index.vue')
const StatisticsPerformanceCompositionView = () =>
  import('@/views/Statistics/Performance/Composition/Index.vue')
const StatisticsPerformanceComparePeriodsView = () =>
  import('@/views/Statistics/Performance/ComparePeriods/Index.vue')
const StatisticsPerformanceTechnicalAnalysisView = () =>
  import('@/views/Statistics/Performance/TechnicalAnalysis/Index.vue')
const StatisticsPerformanceCGCategoriesStatsView = () =>
  import('@/views/Statistics/Performance/CGCategoriesStats/Index.vue')
const StatisticsPerformancePnlAttributionView = () =>
  import('@/views/Statistics/Performance/PnlAttribution/Index.vue')
const StatisticsUSInvestorsView = () =>
  import('@/views/Statistics/USInvestors/Index.vue')

const FuturesView = () => import('@/views/Assets/Futures/Index.vue')
const FuturesPositionsView = () =>
  import('@/views/Assets/Futures/Positions.vue')
const FuturesFundingRatesView = () =>
  import('@/views/Assets/Futures/FundingRates.vue')
const LendingPositionsView = () =>
  import('@/views/Assets/LendingPositions/Index.vue')

// const TradesView = () => import('@/views/Trades/Index.vue')
// const CexView = () => import('@/views/Trades/CEX.vue')
// const CexSpotView = () => import('@/views/Trades/CEX/Spot.vue')
// const CexFuturesView = () => import('@/views/Trades/CEX/Futures.vue')
// const CexOptionsView = () => import('@/views/Trades/CEX/Options.vue')

const ServicesView = () => import('@/views/Services/ServicesIndex.vue')
const SupportedServicesView = () =>
  import('@/views/Services/SupportedServices/Index.vue')
const DeFiSupportedServicesView = () =>
  import('@/views/Services/SupportedServices/DeFi/Index.vue')
const BlockchainsSupportedServicesView = () =>
  import('@/views/Services/SupportedServices/Blockchains/Index.vue')
const MonitoringView = () =>
  import('@/views/Services/Monitoring/MonitoringIndex.vue')
const ReleaseNotesView = () => import('@/views/ReleaseNotes/Index.vue')
const FAQView = () => import('@/views/FAQ/Index.vue')

const NotificationsView = () => import('@/views/Notifications/Index.vue')
const AssetNotificationsView = () =>
  import('@/views/Notifications/AssetNotifications/AssetNotificationsView.vue')
const PortfolioNotificationsView = () =>
  import('@/views/Notifications/PortfolioNotifications/PortfolioNotificationsView.vue')
const FuturesNotificationsView = () =>
  import('@/views/Notifications/FuturesNotifications/FuturesNotificationsView.vue')
const ClaimableNotificationsView = () =>
  import('@/views/Notifications/ClaimableNotifications/ClaimableNotificationsView.vue')
const RemindersView = () =>
  import('@/views/Notifications/Reminders/RemindersView.vue')
const USInvestorsNotificationsView = () =>
  import('@/views/Notifications/USInvestorsNotifications/USInvestorsNotificationsView.vue')

const OnePagerLayout = () => import('@/layouts/OnePager.vue')

import NoPermissionView from '@/views/Auth/NoPermission.vue'

import AppLayout from '@/layouts/App.vue'

import i18n from '../langs'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: AppLayout,
    children: [
      {
        path: '/',
        alias: '/dashboard',
        name: 'DashboardView',
        component: DashboardView,
        meta: {
          name: i18n.global.t('ui.common.dashboard'),
          permission: 2,
        },
      },
      {
        path: '/assets',
        name: 'AssetsView',
        component: AssetsView,
        meta: {
          permission: 3,
          packages: [2, 3, 37, 43],
        },
        children: [
          {
            path: '/assets/futures',
            name: 'FuturesDashboardView',
            redirect: {
              name: 'FuturesPositionsView',
            },
            component: FuturesView,
            meta: {
              name: i18n.global.t('ui.common.futures'),
              permission: 107,
            },
            children: [
              {
                path: '/assets/futures/positions',
                name: 'FuturesPositionsView',
                component: FuturesPositionsView,
              },
              {
                path: '/assets/futures/funding-rates',
                name: 'FuturesFundingRatesView',
                component: FuturesFundingRatesView,
              },
            ],
          },
          {
            path: '/assets/lending',
            name: 'LendingPositionsView',
            component: LendingPositionsView,
            meta: {
              name: i18n.global.t('ui.common.lending_positions'),
              permission: 167,
            },
          },
          {
            path: '/assets/portfolio/:types?',
            name: 'AssetsPortfolioView',
            component: AssetsPortfolioView,
            meta: {
              name: i18n.global.t('ui.common.portfolio'),
              permission: 5,
            },
          },
          {
            path: '/portfolio/sources',
            name: 'AssetSourcesView',
            redirect: {
              name: 'AssetsExchangesView',
            },
            component: AssetSourcesView,
            meta: {
              name: i18n.global.t('ui.common.asset_sources'),
            },
            children: [
              {
                path: '/portfolio/exchanges/:id?',
                name: 'AssetsExchangesView',
                component: AssetsExchangesView,
                meta: {
                  name: i18n.global.t('ui.common.asset_sources'),
                  permission: 7,
                },
              },
              {
                path: '/portfolio/wallets/:id?',
                name: 'AssetsWalletsView',
                component: AssetsWalletsView,
                meta: {
                  name: i18n.global.t('ui.common.asset_sources'),
                  permission: 13,
                },
              },
              {
                path: '/assets/manual-entries/crypto-assets/:id?',
                name: 'AssetsCryptoAssetsView',
                component: AssetsCryptoAssetsView,
                meta: {
                  name: i18n.global.t('ui.common.asset_sources'),
                  permission: 23,
                },
              },
              {
                path: '/assets/manual-entries/custom-entries/:id?',
                name: 'AssetsCustomEntriesView',
                component: AssetsCustomEntriesView,
                meta: {
                  name: i18n.global.t('ui.common.asset_sources'),
                  permission: 31,
                },
              },
            ],
          },
          {
            path: '/assets/zero-price',
            name: 'AssetsZeroPriceAssetsView',
            component: AssetsZeroPriceAssetsView,
            meta: {
              name: i18n.global.t('ui.assets.zero_price_assets'),
              permission: 337,
            },
          },
        ],
      },
      {
        path: '/defi',
        name: 'DeFiView',
        redirect: '/defi/lp',
        component: DeFiView,
        meta: {
          // TODO: Temporary set to permission for Assets.
          // Change to permissions for DeFi after permissions refactoring.
          permission: 3,
          packages: [2, 3, 37, 43],
        },
        children: [
          {
            path: '/defi/lp',
            name: 'LiquidityProvidingView',
            component: LiquidityProvidingView,
            meta: {
              name: i18n.global.t('ui.common.liquidity_providing'),
            },
          },
        ],
      },
      {
        path: '/fund',
        component: FundView,
        meta: {
          permission: 277,
          packages: [3, 43],
        },
        children: [
          {
            path: '/fund/crm',
            name: 'FundCrmView',
            component: FundCrmView,
            redirect: {
              name: 'FundCrmClientsView',
            },
            meta: {
              name: i18n.global.t('ui.common.clients'),
              permission: 43,
            },
            children: [
              {
                path: '',
                name: 'FundCrmClientsView',
                component: FundCrmClientsView,
                meta: {
                  name: i18n.global.t('ui.common.clients'),
                  permission: 43,
                },
              },
              {
                path: ':id',
                name: 'FundCrmClientDetailView',
                component: FundCrmClientDetailView,
                meta: {
                  name: i18n.global.t('ui.common.client_detail'),
                  permission: 43,
                },
                props: true,
              },
            ],
          },
          {
            path: '/fund/fees',
            name: 'FundFeesView',
            component: FundFeesView,
            meta: {
              name: i18n.global.t('ui.common.fees_and_referrers'),
              permission: 53,
            },
          },
          {
            path: '/fund/series',
            name: 'FundSeriesView',
            component: FundSeriesView,
            meta: {
              name: i18n.global.t('ui.common.series_of_shares'),
              permission: 61,
            },
          },
        ],
      },
      {
        path: '/statistics',
        name: 'StatisticsView',
        component: StatisticsView,
        meta: {
          permission: 71,
          packages: [2, 3, 37, 43],
        },
        children: [
          {
            path: '/statistics/performance',
            name: 'StatisticsPerformanceIndexView',
            component: StatisticsPerformanceIndexView,
            meta: {
              name: i18n.global.t('ui.common.statistics'),
              permission: 73,
            },
            children: [
              {
                path: '',
                name: 'StatisticsPerformanceView',
                component: StatisticsPerformanceView,
              },
              {
                path: '/statistics/performance/composition',
                name: 'StatisticsPerformanceCompositionView',
                component: StatisticsPerformanceCompositionView,
              },
              {
                path: '/statistics/performance/compare-periods',
                name: 'StatisticsPerformanceComparePeriodsView',
                component: StatisticsPerformanceComparePeriodsView,
              },
              {
                path: '/statistics/performance/pnl-attribution',
                name: 'StatisticsPerformancePnlAttributionView',
                component: StatisticsPerformancePnlAttributionView,
              },
              {
                path: '/statistics/performance/technical-analysis',
                name: 'StatisticsPerformanceTechnicalAnalysisView',
                component: StatisticsPerformanceTechnicalAnalysisView,
              },
              {
                path: '/statistics/performance/cg-categories-stats',
                name: 'StatisticsPerformanceCGCategoriesStatsView',
                component: StatisticsPerformanceCGCategoriesStatsView,
              },
              {
                path: '/statistics/us-investors',
                name: 'StatisticsUSInvestorsView',
                component: StatisticsUSInvestorsView,
                meta: {
                  name: i18n.global.t('ui.common.us_clients'),
                  permission: 359,
                },
              },
            ],
          },
        ],
      },
      // {
      //   path: '/trades',
      //   name: 'TradesView',
      //   component: TradesView,
      //   meta: {
      //     permission: 89,
      //     packages: [2, 3, 37, 43],
      //   },
      //   children: [
      //     {
      //       path: '/trades/cex',
      //       name: 'CexView',
      //       redirect: {
      //         name: 'CexSpotView',
      //       },
      //       component: CexView,
      //       meta: {
      //         name: i18n.global.t('ui.common.cex'),
      //         permission: 97,
      //       },
      //       children: [
      //         {
      //           path: '/trades/cex/spot',
      //           name: 'CexSpotView',
      //           component: CexSpotView,
      //           meta: {
      //             name: i18n.global.t('ui.common.cex'),
      //           },
      //         },
      //         {
      //           path: '/trades/cex/futures',
      //           name: 'CexFuturesView',
      //           component: CexFuturesView,
      //           meta: {
      //             name: i18n.global.t('ui.common.cex'),
      //           },
      //         },
      //         {
      //           path: '/trades/cex/options',
      //           name: 'CexOptionsView',
      //           component: CexOptionsView,
      //           meta: {
      //             name: i18n.global.t('ui.common.cex'),
      //           },
      //         },
      //       ],
      //     },
      //   ],
      // },
      {
        path: '/account-settings',
        name: 'AccountSettingsView',
        component: AccountSettingsView,
        meta: {
          name: i18n.global.t('ui.common.account_settings'),
        },
      },
      {
        path: '/settings',
        name: 'SettingsView',
        component: SettingsView,
        meta: {
          permission: 191,
        },
        children: [
          {
            path: '/settings/funds',
            name: 'SettingsFundsView',
            component: SettingsFundsView,
            meta: {
              name: i18n.global.t('ui.common.fund_settings'),
              permission: 223,
              packages: [3, 43],
            },
          },
          {
            path: '/settings/portfolios',
            name: 'SettingsPortfoliosView',
            component: SettingsPortfoliosView,
            meta: {
              name: i18n.global.t('ui.common.portfolios'),
              // TODO: Add perission
              // permission: XXX,
              packages: [2, 37],
            },
          },
          {
            path: '/settings/users',
            name: 'SettingsAdminsView',
            component: SettingsAdminsView,
            redirect: {
              name: 'SettingsAdminsListView',
            },
            meta: {
              name: i18n.global.t('ui.common.admins'),
              permission: 199,
              packages: [3, 43],
            },
            children: [
              {
                path: '',
                name: 'SettingsAdminsListView',
                component: SettingsAdminsListView,
              },
              {
                path: 'activity-log',
                name: 'SettingsAdminsActivityLogView',
                component: SettingsAdminsActivityLogView,
              },
              {
                path: ':rootUserId',
                name: 'SettingsAdminDetailView',
                component: SettingsAdminDetailView,
                props: true,
              },
            ],
          },
        ],
      },
      {
        path: '/services',
        name: 'Services',
        component: ServicesView,
        meta: {
          permission: 331,
        },
        children: [
          {
            path: '/services/supported-services',
            name: 'SupportedServicesView',
            redirect: '/services/supported-services/defi',
            component: SupportedServicesView,
            meta: {
              permission: 283,
              name: i18n.global.t('ui.common.supported_services'),
            },
            children: [
              {
                path: '/services/supported-services/defi',
                name: 'DeFiSupportedServicesView',
                component: DeFiSupportedServicesView,
              },
              {
                path: '/services/supported-services/blockchains',
                name: 'BlockchainsSupportedServicesView',
                component: BlockchainsSupportedServicesView,
              },
            ],
          },
          {
            path: '/services/monitoring',
            name: 'MonitoringView',
            component: MonitoringView,
            meta: {
              permission: 313,
              name: i18n.global.t('ui.common.monitoring'),
            },
          },
        ],
      },
      {
        path: '/notifications',
        name: 'NotificationsView',
        component: NotificationsView,
        meta: {
          name: i18n.global.t('ui.notifications.title'),
          permission: 239,
        },
        children: [
          {
            path: '/notifications/assets',
            name: 'AssetNotificationsView',
            component: AssetNotificationsView,
            meta: {
              name: i18n.global.t('ui.notifications.title'),
              permission: 5,
            },
          },
          {
            path: '/notifications/portfolio',
            name: 'PortfolioNotificationsView',
            component: PortfolioNotificationsView,
            meta: {
              name: i18n.global.t('ui.notifications.title'),
              permission: 5,
            },
          },
          {
            path: '/notifications/futures',
            name: 'FuturesNotificationsView',
            component: FuturesNotificationsView,
            meta: {
              name: i18n.global.t('ui.notifications.title'),
              permission: 107,
            },
          },
          {
            path: '/notifications/claimables',
            name: 'ClaimableNotificationsView',
            component: ClaimableNotificationsView,
            meta: {
              name: i18n.global.t('ui.notifications.title'),
              permission: 13,
            },
          },
          {
            path: '/notifications/reminders',
            name: 'RemindersView',
            component: RemindersView,
            meta: {
              name: i18n.global.t('ui.notifications.title'),
            },
          },
          {
            path: '/notifications/us-investors',
            name: 'USInvestorsNotificationsView',
            component: USInvestorsNotificationsView,
            meta: {
              name: i18n.global.t('ui.notifications.title'),
              permission: 359,
            },
          },
        ],
      },
      {
        path: '/no-permission',
        name: 'NoPermissionView',
        component: NoPermissionView,
        meta: {
          name: i18n.global.t('ui.common.no_permission'),
        },
      },
      {
        path: '/release-notes',
        name: 'ReleaseNotesView',
        component: ReleaseNotesView,
        meta: {
          name: i18n.global.t('ui.common.release_notes'),
        },
      },
      {
        path: '/faq',
        name: 'FAQView',
        component: FAQView,
        meta: {
          name: i18n.global.t('ui.common.faq'),
        },
      },
    ],
  },
  {
    path: '/fund/:fundId/view/:entityId',
    component: OnePagerLayout,
    children: [
      {
        path: '',
        name: 'ClientFund',
        component: FundCrmClientFundView,
        meta: {
          permission: 43,
        },
      },
    ],
  },
  {
    path: '/fund/:fundId/referrer-view/:entityId',
    component: OnePagerLayout,
    children: [
      {
        path: '',
        name: 'ReferrerOnePager',
        component: FundReferrerOnePagerView,
        meta: {
          permission: 53,
        },
      },
    ],
  },
]

export default routes
